import React, { FC } from 'react'
import styled from 'styled-components'
import Fonts from 'components/base-ui/Fonts'

interface LabelStatusProps {
  label: string
  backgroundColor: string
}

const Label: FC<LabelStatusProps> = ({ label, backgroundColor }) => {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Fonts.SmallTitleBold>{label}</Fonts.SmallTitleBold>
    </Wrapper>
  )
}

export default Label

const Wrapper = styled.div<{ backgroundColor: string }>`
  color: ${(props) => props.theme.colors.white};
  background-color: ${({ backgroundColor }) => backgroundColor};
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  width: fit-content;
`
